import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent6"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code6-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code6-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "BG Alerts with Icon", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab6",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview6-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview6-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview6-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code6-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code6-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code5-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview6-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview6-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", {
            class: "alert alert-primary bg-primary text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-home-7-line fs-18 me-1" }),
            _createTextVNode(" A simple primary alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-secondary bg-secondary text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-star-line fs-18 me-1" }),
            _createTextVNode(" A simple secondary alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-success bg-success text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-play-circle-line fs-18 me-1" }),
            _createTextVNode(" A simple success alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-danger bg-danger text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-service-line fs-18 me-1" }),
            _createTextVNode(" A simple danger alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-warning bg-warning text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-edit-box-line fs-18 me-1" }),
            _createTextVNode(" A simple warning alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-info bg-info text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-table-line fs-18 me-1" }),
            _createTextVNode(" A simple info alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-light bg-light text-white",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-code-s-slash-fill fs-18 me-1" }),
            _createTextVNode(" A simple light alert—check it out! ")
          ]),
          _createElementVNode("div", {
            class: "alert alert-dark bg-dark text-white mb-0",
            role: "alert"
          }, [
            _createElementVNode("i", { class: "ri-html5-line fs-18 me-1" }),
            _createTextVNode(" A simple dark alert—check it out! ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode6"
            }, "\n<div class=\"alert alert-primary bg-primary text-white\" role=\"alert\">\n  <i class=\"ri-home-7-line fs-18 me-1\"></i>\n  A simple primary alert—check it out!\n</div>\n<div class=\"alert alert-secondary bg-secondary text-white\" role=\"alert\">\n  <i class=\"ri-star-line fs-18 me-1\"></i>\n  A simple secondary alert—check it out!\n</div>\n<div class=\"alert alert-success bg-success text-white\" role=\"alert\">\n  <i class=\"ri-play-circle-line fs-18 me-1\"></i>\n  A simple success alert—check it out!\n</div>\n<div class=\"alert alert-danger bg-danger text-white\" role=\"alert\">\n  <i class=\"ri-service-line fs-18 me-1\"></i>\n  A simple danger alert—check it out!\n</div>\n<div class=\"alert alert-warning bg-warning text-white\" role=\"alert\">\n  <i class=\"ri-edit-box-line fs-18 me-1\"></i>\n  A simple warning alert—check it out!\n</div>\n<div class=\"alert alert-info bg-info text-white\" role=\"alert\">\n  <i class=\"ri-table-line fs-18 me-1\"></i>\n  A simple info alert—check it out!\n</div>\n<div class=\"alert alert-light bg-light text-white\" role=\"alert\">\n  <i class=\"ri-code-s-slash-fill fs-18 me-1\"></i>\n  A simple light alert—check it out!\n</div>\n<div class=\"alert alert-dark bg-dark text-white mb-0\" role=\"alert\">\n  <i class=\"ri-html5-line fs-18 me-1\"></i>\n  A simple dark alert—check it out!\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}